module.exports = __webpack_public_path__ + "static/media/webrtc.fc344d99.svg";